import { create } from "zustand";
import { ActionsKey } from "../../../../common/models/Actions";
import {
  initialGateOutPageState,
  GateOutItemData,
} from "../core/_model.gateOut";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../../common/models/StoreDefaultModel";

export type ActionedGateOut = {
  data: GateOutItemData | null;
  action: ActionsKey;
};

type GateOutDataType = {
  gateOutList: any;
  detail: GateOutItemData | null;
  actioned: ActionedGateOut | null;
  totalItems?: number;
  setDetail: (detail: GateOutItemData | null) => void;
  setGateOutList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedGateOut | null) => void;
};

export const useGateOutStore = create<GateOutDataType>(
  (set) => ({
    gateOutList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setGateOutList: (saleData) =>
      set((state) => ({
        gateOutList: saleData?.member,
        totalItems: saleData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useGateOutListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialGateOutPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
